import { Pipe, PipeTransform } from '@angular/core';

// Moment
import * as moment from 'moment';

@Pipe({
  name: 'notificationDateFormat'
})
export class NotificationDateFormatPipe implements PipeTransform {

  // Transform
  public transform(value: any, args?: string): any {
    const language: string = args ? args.split('-')[0] : 'en';

    return moment(value * 1000).locale(language).format('MMMM Do, h:mm a');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/notification-date-format/notification-date-format.pipe.ts